import { styled } from "@mui/system";

export const StyledProgressBar = styled("div")(({ theme, isMobile }) => ({
  flex: "1",
  "& .MuiLinearProgress-root": {
    backgroundColor: isMobile ? "rgb(26 26 26 / 60%)" : "rgb(255 255 255 / 60%)",
    borderRadius: "5px"
  },
  "& .MuiLinearProgress-bar": {
    backgroundColor: isMobile ? "#000" : "#fff"
  },
  "& .mobileProgressBar.progressBarStep.inActive.MuiBox-root": {
    opacity: "1"
  },
  "& .mobileProgressBar.progressBarStep.completed.MuiBox-root": {
    opacity: "1"
  },
  "& .progressBarStep.inActive.MuiBox-root": {
    opacity: "0.6"
  },
  "& .progressBarStep.completed.MuiBox-root": {
    opacity: "0.6"
  },
  "& .progressBarStepHeader": {
    display: "flex",
    alignItems: "center",
    gap: "2px",
    marginBottom: "5px",

    "& .progressBarIcon": {
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  },
  "& .progressBarLabel": {
    fontSize: "0.75rem",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    color: "#fff",
    opacity: "1",
    textWrap: "nowrap",
    [theme.breakpoints.up("md")]: {
      fontSize: "0.875rem"
    }
  }
}));

export const StyledProgressBarContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "1rem",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
  [theme.breakpoints.between("sm", "lg")]: {
    gap: "0.5rem"
  },

  "& .mobileProgressBarContainer": {
    width: "100%",
    padding: "0rem 0rem 1.5rem",
    "& .mobileProgressContainer": {
      display: "flex",
      flexDirection: "column",
      gap: "11px"
    },
    "& .mobileProgressBarLabel": {
      display: "flex",
      gap: "4px",
      alignItems: "center",
      "& .mobileProgressLabelStep": {
        color: "#717171",
        fontSize: "14px",
        fontWeight: 500
      },
      "& .mobileProgressLabelStepName": {
        fontSize: "14px",
        fontWeight: "500"
      }
    }
  },
  "& .mobileProgressBarStepper": {
    display: "flex",
    gap: "10px"
  },
  "& .desktopProgressBarContainer": {
    maxWidth: "8.125rem",
    flex: 1,
    [theme.breakpoints.up("lg")]: {
      // width: "10.3rem",
      maxWidth: "10.3rem"
    }
  }
}));
